import {Questionnaire, ScipSubmissionData, SurveyPageType} from "../../../Models/Surveys/SurveyDataModel";
import { CoreSurveyResponseData, InventoryDetailsResponse, SurveyResponseValidationResult, ComplianceScoreResult } from "./SurveyResponseModels";
import {BaseRegulationLogicManager} from "../../../Managers/BaseRegulationLogicManager";

export interface ProgressState {
    title: string;
    current: string;
    currentInventoryId?: string;
    next?: string;
    maxProgress: number;
    currentProgress: number;
}

export interface NavContext {
    // large-surveys // add pageIndex to keep track of which page of materials the user is on right now
    mainNavIndex: SurveyPageType;
    currentPageOfMaterialsIndex: number;
    inventoryNavIndex: number;
    surveyQuestionnaireIndex: number;
    surveyQuestionnairePageIndex: number;
    previousPageStack: number[]; // Keep track of the jump statements that direct the user outside of the default flow when using the next and back actions
    //currentlySelectedScipMaterialNodeRowIndex: number; // the currently selected SCIP material node
    currentlySelectedScipSubmissionData: ScipSubmissionData | null;
    selectedInventoryPageIndex: number | 0;
    selectedInventoryId: string; //keep track of the current selected inventory for state management
}

export enum InventoryQuestionnaireType {
    BaseQuestionnaire = "BaseQuestionnaire",
    CustomQuestionnaire = "CustomQuestionnaire",
    AttestationQuestionnaire = "AttestationQuestionnaire"
}

export interface SurveyResponseState {
    responseId: string;
    language: string;
    progressState: ProgressState;
    dataLoaded: boolean;
    pageDataLoaded: boolean;
    showErrorMessage: boolean;
    showNotFoundErrorScreen: boolean;
    coreData: CoreSurveyResponseData | null;
    selectedInventory: InventoryDetailsResponse | null;
    validationResult: SurveyResponseValidationResult;
    navContext: NavContext;
    surveyQuestionnairesList: Questionnaire[];
    questionnairesTypes: InventoryQuestionnaireType[];
    insActiveLanguage: string;
    regulationManager: BaseRegulationLogicManager | null;
}
